var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_168_34900)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.41094 3.4724C8.41094 2.81474 8.41094 2.48591 8.30369 2.22694C8.23276 2.0556 8.12876 1.89991 7.99763 1.76878C7.8665 1.63765 7.71082 1.53365 7.53947 1.46273C7.2805 1.35547 6.95167 1.35547 6.29401 1.35547H4.17707C2.84623 1.35547 2.18151 1.35547 1.768 1.76898C1.35449 2.18248 1.35449 2.8472 1.35449 4.17805V6.29498C1.35449 6.95265 1.35449 7.28148 1.46175 7.54045C1.53268 7.71179 1.63668 7.86748 1.76781 7.99861C1.89893 8.12974 2.05462 8.23374 2.22596 8.30466C2.48494 8.41192 2.81377 8.41192 3.47143 8.41192",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2331 5.58984H6.99918C6.21975 5.58984 5.58789 6.2217 5.58789 7.00113V11.235C5.58789 12.0144 6.21975 12.6463 6.99918 12.6463H11.2331C12.0125 12.6463 12.6443 12.0144 12.6443 11.235V7.00113C12.6443 6.2217 12.0125 5.58984 11.2331 5.58984Z",
    stroke: "white",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_168_34900"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyNew);
export default __webpack_public_path__ + "static/media/copyNew.3949a5d6032d66b69916c9ad09db785e.svg";
export { ForwardRef as ReactComponent };